import { ApolloCache, gql } from '@apollo/client';
import { rewardFragment } from '../fragments/reward';
import { CreateRewardMutation, GetRewardsQuery, GetRewardsQueryVariables } from '../generated/graphql';
import { getRewardsQuery } from '../queries/rewards';

export const createRewardMutation = gql`
    ${rewardFragment}
    
    mutation CreateReward(
      $name: String!,
      $description: String!,
      $price: Int!,
      $rarity: RewardRarity!,
      $icon: String!,
    ) {
        createReward(
          data: { 
            name: $name, 
            description: $description, 
            price: $price,
            rarity: $rarity,
            icon: $icon
          }) 
        {
          ...RewardFields
        }
    }
`;

const updateGetProfile = (cache: ApolloCache<any>, { data }: { data?: CreateRewardMutation | null }) => {
  const oldData = cache.readQuery<GetRewardsQuery, GetRewardsQueryVariables>({ query: getRewardsQuery });
  if (!oldData?.rewards) return;
  
  const reward = data!.createReward!;
  const newRewards = [...oldData.rewards, reward];
  cache.writeQuery<GetRewardsQuery, GetRewardsQueryVariables>({
    query: getRewardsQuery,
    data: { ...oldData, rewards: newRewards}
  });
}

export function createRewardCache(cache: ApolloCache<any>, mutationData: { data?: CreateRewardMutation | null }) {
  updateGetProfile(cache, mutationData);
}